import * as Sentry from "@sentry/vue";
import * as config from "./config.js";
import type { App } from "vue";
import type { Router } from "vue-router";

/**
 * Initialize Sentry monitoring for a Vue application.
 *
 * @param app - The Vue application instance
 * @param router - Optional Vue Router instance for performance monitoring
 */
export function initSentry(app: App, router?: Router) {
  // Skip initialization if no DSN is configured
  if (!config.monitoring.sentry.dsn) {
    console.warn("Sentry DSN not configured, skipping initialization");
    return;
  }

  const integrations = [];

  // Add browser tracing integration if router is provided
  if (router) {
    integrations.push(Sentry.browserTracingIntegration({ router }));
  }

  Sentry.init({
    app,
    dsn: config.monitoring.sentry.dsn,
    environment: config.monitoring.sentry.environment,
    integrations,
    tracesSampleRate: config.monitoring.sentry.tracesSampleRate,
    tracePropagationTargets: config.monitoring.sentry.tracePropagationTargets,
  });
}
